import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDfCu4GN23_WnDBr0_2ODh-pyTvpMzJEdA",
  authDomain: "vb-events.firebaseapp.com",
  databaseURL: "https://vb-events.firebaseio.com",
  projectId: "vb-events",
  storageBucket: "vb-events.firebasestorage.app",
  messagingSenderId: "755782043124",
  appId: "1:755782043124:web:65965e93891f1574b465a1",
  measurementId: "G-DFXB51Y6SW",
};

const app = initializeApp(firebaseConfig);

const logAnalyticsEvent = (name, params) => {
  if (process.env.NODE_ENV === "production") {
    const analytics = getAnalytics(app);
    if (analytics) {
      logEvent(analytics, name, params);
    }
  }
};

export { app, logAnalyticsEvent };
